import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProtoDotIoComponent } from './simple-icons-proto-dot-io.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProtoDotIoComponent ],
    exports:      [ SimpleIconsProtoDotIoComponent ],
    bootstrap:    []
})
export class SimpleIconsProtoDotIoModule {}
